import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { AsnLineRead } from '../../entities/asn-line.dto';

@Injectable()
export class AsnLineStore extends AbstractEntityStore<AsnLineRead> {
    constructor() {
        super(PFWmsEntities.AsnLine);
    }
}
